export const BROADCAST_ADDRESS = 0xffffffff;
export const roleOptions = [
  { value: "admin", label: "Admin" },
  { value: "user", label: "Utilisateur" },
  { value: "client", label: "Client" },
  { value: "provider", label: "Fournisseur" },
  { value: "manager", label: "Responsable" },
  { value: "technician", label: "Technicien" },
  { value: "sales", label: "Commercial" },
  { value: "other", label: "Autre" },
];

export const RoleOptions = () => {
  return roleOptions.map((option) => (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
  ));
};
